import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-3 max-h-[350px] overflow-auto scroll-style" }
const _hoisted_2 = { class: "bg-gray-50 rounded shadow border px-5 py-2 my-3 cursor-pointer" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "text-lg truncate max-w-lg font-bold" }
const _hoisted_5 = { class: "flex items-center gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyData = _resolveComponent("EmptyData")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_OrderButtons = _resolveComponent("OrderButtons")!
  const _component_Draggable = _resolveComponent("Draggable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_EmptyData, {
      data: !_ctx.value || _ctx.value.length === 0,
      image: 'empty-materials.svg',
      imgSize: "h-40"
    }, null, 8, ["data", "image"]),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_Draggable, {
        modelValue: _ctx.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
        itemKey: "index",
        onEnd: _ctx.onEnd
      }, {
        item: _withCtx(({ element, index }) => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", _hoisted_4, _toDisplayString(element.name), 1),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_Button, {
                  class: "btn-simple",
                  onClick: _withModifiers(($event: any) => (_ctx.$emit('onEdit', element)), ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      name: "md-edit",
                      class: "text-h-primary-500"
                    })
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_Button, {
                  class: "btn-delete",
                  onClick: _withModifiers(($event: any) => (_ctx.onDelete(element)), ["prevent"]),
                  disabled: _ctx.loading
                }, {
                  default: _withCtx(() => [
                    (_ctx.loading && _ctx.currentItem === element)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          name: "ri-loader-5-fill",
                          class: "text-red-700 animate-spin"
                        }))
                      : (_openBlock(), _createBlock(_component_v_icon, {
                          key: 1,
                          name: "md-delete",
                          class: _normalizeClass(['text-red-700'])
                        }))
                  ]),
                  _: 2
                }, 1032, ["onClick", "disabled"]),
                _createVNode(_component_OrderButtons, {
                  "all-data": _ctx.value,
                  data: element,
                  index: index,
                  onOnOrder: ($event: any) => (_ctx.generics.onOrder($event, index, _ctx.value, _ctx.updateOrder))
                }, null, 8, ["all-data", "data", "index", "onOnOrder"])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "onEnd"])
    ])
  ], 64))
}